import { createFileRoute, useNavigate, useSearch } from '@tanstack/react-router';
import { useEffect } from 'react';
import { HStack } from '@/components/Layout';
import { CERTIFICATION_KIND_STEPS } from '../-constants/steps';
import useCertificationKindParam from '../-hooks/useCertificationKind';
import { getCertificationFormStoreContext } from '../-store/certificationFormStoreContext';
import InnerNavigation from './-components/InnerNavigation';
import ManualForm from './-components/ManualForm';
import { ProgressCard } from './-components/ProgressCard';
export const Route = createFileRoute('/_staff/person/add-person-certification/$certificationKind/')({
  component: () => <Form />
});
function Form() {
  const {
    certificationKind
  } = useCertificationKindParam();
  const {
    context
  } = getCertificationFormStoreContext(certificationKind);
  const store = context.createStore();
  const steps = CERTIFICATION_KIND_STEPS[certificationKind];

  // QueryParameterからpersonId、certificationIdを取得
  const formStore = store.getState();
  const search = useSearch({
    strict: false
  }) as {
    personId?: string;
    certificationId?: string;
  };
  const navigate = useNavigate();
  useEffect(() => {
    if (search.personId) {
      formStore.actions.setPersonId(search.personId);
    }
    if (search.certificationId) {
      formStore.actions.setCertificationId(search.certificationId);
    }
    if (!formStore.actions.getPersonId() || !formStore.actions.getCertificationId()) {
      navigate({
        to: '/person/add-person-certification'
      });
    }
  }, [search.personId, search.certificationId, formStore.actions, navigate]);
  return <context.Provider value={store}>
      <HStack className="w-full p-6 gap-6">
        <div className="shrink-0">
          <InnerNavigation steps={steps.map(step => step.step)} />
        </div>
        <ManualForm className="grow min-w-[340px]" steps={steps} />
        <div className="shrink-0">
          <ProgressCard steps={steps.map(step => step.step)} />
        </div>
      </HStack>
    </context.Provider>;
}